import {
    SET_CART_DATA, RESET_CART_DATA
} from './../constants/constants';

const initialState = {
    quoteId: '',
    products: [],
    quote: '',
    premiumCalculationError: false,

}

const profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CART_DATA:
            return {
                ...state,
                quoteId: ('quoteId' in action.payload) ? action.payload.quoteId : state.quoteId,
                products: ('products' in action.payload) ? action.payload.products : state.products,
                quote: ('quote' in action.payload) ? action.payload.quote : state.quote,
                premiumCalculationError: ('premiumCalculationError' in action.payload) ? action.payload.premiumCalculationError : state.premiumCalculationError,
            }
        case RESET_CART_DATA:
            return {
                quoteId: '',
                products: [],
                quote: '',
                premiumCalculationError: false,
            }
        default:
            return state
    }
}

export default profileReducer;